// ============================================================
// USUÁRIOS DO SISTEMA
// Adicione ou remova usuários aqui conforme necessário.
// ============================================================

const USERS = [
  { username: "admin",  password: "rop2024",  name: "Administrador" },
  { username: "acors",  password: "acors123", name: "Acors" },
  // Adicione mais usuários abaixo:
  // { username: "outro", password: "senha123", name: "Nome do Usuário" },
];

export default USERS;
